import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useScrollToTop } from '@/hooks/useScrollToTop';

export default function Home() {
  useScrollToTop();
  const { setMeta } = useDocumentMeta();

  const ogImage = "https://readdy.ai/api/search-image?query=Abstract%20warm%20elegant%20content%20platform%20brand%20image%20with%20soft%20cream%20and%20terracotta%20tones%2C%20minimal%20editorial%20design%2C%20clean%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape";

  useEffect(() => {
    setMeta({
      title: '精品一区·优选内容汇聚地 - 高质量精选内容平台',
      description: '精品一区是您发现高质量精选内容的首选平台，汇聚严选优质资源，为您提供极致体验。无论您追求品质生活、精品内容还是优选服务，精品一区都能满足您的高端需求，立即探索精品一区带来的全新体验。',
      keywords: '精品一区,精品一区内容,精品一区资源,精品一区优选,精品一区合集,高质量精品区,精品内容推荐',
      canonicalUrl: 'https://jingpinyiqu.com',
      ogImage,
      ogType: 'website',
      structuredData: {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            name: '精品一区',
            url: 'https://jingpinyiqu.com',
            description: '精品一区是您发现高质量精选内容的首选平台，汇聚严选优质资源。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-9999',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
            sameAs: [],
          },
          {
            '@type': 'WebSite',
            name: '精品一区',
            url: 'https://jingpinyiqu.com',
            potentialAction: {
              '@type': 'SearchAction',
              'target': 'https://jingpinyiqu.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
          {
            '@type': 'WebPage',
            name: '精品一区首页',
            description: '精品一区·优选内容汇聚地 - 发现高质量精选内容的首选平台',
            url: 'https://jingpinyiqu.com',
            isPartOf: { '@type': 'WebSite', name: '精品一区' },
          },
        ],
      },
    });
  }, [setMeta]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}